export default __webpack_public_path__ + "static/media/reporting_icon_red.429d3abd.svg";